// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__18SB1","threesixtyIcon":"threesixtyIcon__13LGb"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/gemComponentsView/scss/gemComponentsView.scss
// module id = PJ3B
// module chunks = 0